export default "__VITE_ASSET__pv$ZzRrj__"